import { post } from './apiServices'

export var account = null;
export var token = null;
export var ttrToken = null;

export function logIn(email="", password=""){
    return post('/auth/admin-login', {
		'email' : email,
        'password' : password,
        'type': 'admin'
	}).then(res =>{
        return res.data;
    })
}

export function logInByToken(token=""){
    return post('/auth/login-by-token', {
		'token' : token,
        'type': 'admin'
	}).then(res =>{
        return res.data;
    })
}

export function logOut(){
    account = null
    token = null
    ttrToken = null
    return localStorage.setItem('account', '');
}

export function storeAccountData(data = {}){
    account = data ? data : null
    token = data && data.token ? data.token : null
    ttrToken = data && data.ttrToken ? data.ttrToken : null
    return localStorage.setItem('account', JSON.stringify(data));
}

export function restoreAccountData(){
    let accountString = localStorage.getItem('account');
    let data = accountString ? JSON.parse(accountString) : null
    if(data && data.token){
        data.loggedIn = true;
    }
    account = data ? data : null
    token = data && data.token ? data.token : null
    ttrToken = data && data.ttrToken ? data.ttrToken : null
    return data
}



// WEBPACK FOOTER //
// ./src/services/authServices.js